<template>
  <div class="outlet-wrapper">
    <ion-skeleton-text animated class="outlet-image"></ion-skeleton-text>
    <div class="outlet-info">
      <ion-skeleton-text animated class="outlet-name"></ion-skeleton-text>
      <ion-skeleton-text animated class="outlet-address"></ion-skeleton-text>
    </div>
  </div>
</template>

<script>
import { IonSkeletonText } from "@ionic/vue";

export default {
  name: "OutletSkeleton",
  components: { IonSkeletonText },
};
</script>

<style scoped>
.outlet-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #fff;
  border-radius: 16px;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
}

.outlet-image {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  flex-shrink: 0;
}

.outlet-info {
  flex: 1;
}

.outlet-name {
  width: 70%;
  height: 14px;
  border-radius: 6px;
  margin-bottom: 6px;
}

.outlet-address {
  width: 90%;
  height: 12px;
  border-radius: 6px;
}
</style>